import React from 'react';
import { Modal, FormGroup, Button } from 'react-bootstrap';
import { Label } from 'fw/components';
import { Form, TextAreaBox } from 'fw/forms';
import { DocumentUpload } from 'areas/shared/controls';

// NVBDC-1404 — pencil-icon popup, local-state-only (see CapabilitiesPopUp.js for the pattern note).
class AccreditationsPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,
            form: {
                professionalAccreditation: props.professionalAccreditation || '',
                professionalAccreditationStorageToken: props.professionalAccreditationStorageToken || null,
                professionalAccreditationFileName: props.professionalAccreditationFileName || null
            }
        };
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            visible: nextProps.visible,
            form: {
                professionalAccreditation: nextProps.professionalAccreditation || '',
                professionalAccreditationStorageToken: nextProps.professionalAccreditationStorageToken || null,
                professionalAccreditationFileName: nextProps.professionalAccreditationFileName || null
            }
        });
    }

    onChange = (form) => {
        this.setState({ form });
    };

    handleUploadChange = (file) => {
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                professionalAccreditationStorageToken: file.storageToken,
                professionalAccreditationFileName: file.fileName
            }
        }));
    };

    save = () => {
        this.props.onSave(this.state.form);
        this.close();
    };

    close = () => {
        this.setState({ visible: false }, () => this.props.onClose());
    };

    render() {
        return (
            <Modal show={this.state.visible} onHide={this.close}>
                <Modal.Header>
                    <h3>Company Accreditations</h3>
                </Modal.Header>
                <Modal.Body>
                    <Form onChange={this.onChange} values={this.state.form} ref={(form) => { this._form = form; }}>
                        <FormGroup>
                            <Label htmlFor="professionalAccreditation">List your company's accreditations</Label>
                            <TextAreaBox name="professionalAccreditation" placeholder="e.g. Kosher certification, ITAR, ISO9001" rows={4} maxLength={1000} />
                        </FormGroup>
                        <FormGroup>
                            <Label>Supporting Documentation</Label>
                            <DocumentUpload
                                storageToken={this.state.form.professionalAccreditationStorageToken}
                                fileName={this.state.form.professionalAccreditationFileName}
                                onChange={this.handleUploadChange}
                            />
                        </FormGroup>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button id="btnSaveAccreditations" bsStyle="success" onClick={this.save}>Save</Button>
                    <Button id="btnCloseAccreditations" onClick={this.close}>Close</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default AccreditationsPopUp;



// WEBPACK FOOTER //
// ./src/areas/certification/oneSheet/popups/AccreditationsPopUp.js